import React from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

export default function HallOfFame({ config, onChange }) {
  const updateTop = (value) => {
    onChange({ ...config, top: value });
  };

  const updateToday = (value) => {
    onChange({ ...config, today: value });
  };
  const updateWeek = (value) => {
    onChange({ ...config, week: value });
  };
  const updateMonth = (value) => {
    onChange({ ...config, month: value });
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="subtitle2">Display</Typography>

      <Box display="flex" gap={2} alignItems="flex-end" flexWrap="wrap">
        {/* Show Dropdown */}
        <FormControl size="small" style={{ minWidth: 80 }}>
          <InputLabel>Top</InputLabel>
          <Select
            value={config.top}
            label="Top"
            onChange={(e) => updateTop(e.target.value)}
          >
            <MenuItem value="5">5</MenuItem>
            <MenuItem value="10">10</MenuItem>
            <MenuItem value="15">15</MenuItem>
            <MenuItem value="20">20</MenuItem>
          </Select>
        </FormControl>

        {/* All Games Checkbox */}
        <FormControlLabel
          control={
            <Checkbox
              checked={config.today}
              onChange={(e) => updateToday(e.target.checked)}
              disabled={true}
            />
          }
          label="Today"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={config.week}
              onChange={(e) => updateWeek(e.target.checked)}
              disabled={true}
            />
          }
          label="Week"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={config.month}
              onChange={(e) => updateMonth(e.target.checked)}
              disabled={true}
            />
          }
          label="Month"
        />
      </Box>
    </Box>
  );
}
